// src/components/Contact.jsx

import React, { useState } from "react";
import "./Contact.css";
import { Slide, Zoom } from "react-awesome-reveal";

import logo from "../assets/logo moldura.svg";
import bg from "../assets/bg.svg";
// import icons from "../assets/icons";

// const LogoIcon = icons["LogoIcon"];

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    const phoneNumber = "5527992613367";
    const text = `Olá! Gostaria de um contato.\n\n*Nome:* ${name}\n*Email:* ${email}\n\n*Mensagem:*\n${message}`;

    const encodedText = encodeURIComponent(text);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedText}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <section
      id="contacts"
      className="contact-section"
      style={{
        backgroungImage: `url(${bg})`,
      }}
    >
      <div className="contact-container">
        <Slide direction="left" triggerOnce>
          <div className="contact-form-wrapper">
            <div className="contact-form-wrapper">
              <h2 className="contact-title">
                Fale <span className="secondary-color">Conosco</span>
              </h2>
              <p className="contact-description">
                Tem um projeto ou uma dúvida? Preencha os campos e fale conosco
                diretamente no WhatsApp.
              </p>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Nome Completo*</label>
                  <input
                    id="name"
                    type="text"
                    placeholder="Seu nome"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Seu email*</label>
                  <input
                    id="email"
                    type="email"
                    placeholder="Seu melhor email para contato"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Mensagem*</label>
                  <textarea
                    id="message"
                    placeholder="Como podemos ajudar?"
                    rows="5"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  ></textarea>
                </div>
                <button type="submit" className="submit-btn">
                  Enviar via WhatsApp
                </button>
              </form>
            </div>
          </div>
        </Slide>
        <Zoom triggerOnce>
          <div className="contact-image-wrapper">
            <img
              src={logo}
              alt="Abstrato DB Vision"
              className="contact-image"
            />
          </div>
        </Zoom>
      </div>
    </section>
  );
};

export default Contact;
